module.exports = __webpack_public_path__ + "img/inspiration_03@2x.a3ce1d4.jpg";